// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__FJrSu","wrapper":"styles_wrapper__1eo4T"};